// Lightweight Google Analytics 4 loader.
// Only initializes when REACT_APP_GA4_MEASUREMENT_ID is defined at build time.

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

let initialized = false;

export const initAnalytics = () => {
  if (initialized) return;
  if (!GA_ID) return; // silently skip if not configured
  if (typeof window === 'undefined') return;

  // Inject the gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  // Delay page_view; we send it manually on route change to support SPA.
  gtag('config', GA_ID, { send_page_view: false });

  initialized = true;
};

export const trackPageView = (path, title) => {
  if (!GA_ID) return;
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!GA_ID) return;
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
};

export const isAnalyticsEnabled = () => Boolean(GA_ID);
